export default __webpack_public_path__ + "static/media/happy-face.e86bef5c.png";